export const surveyEndPoint = `questionnaires/count`;
